import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import vrs from "../../Assets/Projects/vrs.png";
import weather from "../../Assets/Projects/weather.png";
import ids from "../../Assets/Projects/ids.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard 
              imgPath={weather }
              isBlog={false}
              title="WeatherKast"
              description="Weather Forecast Application that Accurately predicts  weather based on various  parameters such as temperature,   humidity and other atmospheric phenomenon."
              ghLink="https://github.com/avdhesh201/WeatherKast"
              demoLink="https://avdhesh201.github.io/WeatherKast/"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ids}
              isBlog={false}
              title="Intrusion detection system"
              description="A hybrid Intrusion Detection System for IoV to detect various cyber attacks in the Autonomous Vehicles
              networks, which also calculates attack types, detection rate and their F1-score."
              
              ghLink="https://github.com/avdhesh201/Intrusion-Detection-System"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vrs}
              isBlog={false}
              title="Vaccine-registration-system"
              description="It is a  simple logical terminal based vaccine registration system where user can register themselevs for vaccine by providing some basic details like Name , contact , age and vaccine type "
              
              ghLink="https://github.com/avdhesh201/vaccine-registration-system"
                        
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
